import SectionTitle from "./SectionTitle";
import { settingsTips } from "@/mocks/home";

export default function SettingsTips() {
  return (
    <section id="settings" className="bg-background-100 border-y border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="画质与网络设置"
          title="几个小设置，让播放更稳"
          desc="这些建议不需要额外工具，调整一次就能长期受益，尤其适合经常遇到卡顿的用户。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {settingsTips.map((tip, idx) => (
            <div
              key={tip.title}
              className="flex gap-4 rounded-lg bg-background-50 border border-background-200 p-5"
            >
              <span
                className={`shrink-0 w-11 h-11 rounded-lg flex items-center justify-center ${
                  idx % 3 === 0
                    ? "bg-primary-100 text-primary-700"
                    : idx % 3 === 1
                      ? "bg-accent-100 text-accent-700"
                      : "bg-secondary-100 text-secondary-800"
                }`}
              >
                <i className={`${tip.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="text-base font-semibold text-foreground-950">{tip.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}